"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var client_exports = {};
__export(client_exports, {
  getClient: () => getClient
});
module.exports = __toCommonJS(client_exports);
var import_utils = require("./utils");
function getClient(baseUrl, workspace, token) {
  return new Client(baseUrl, workspace, token);
}
__name(getClient, "getClient");
class Client {
  constructor(baseUrl, workspace, token) {
    this.baseUrl = baseUrl;
    this.workspace = workspace;
    this.token = token;
    this.baseUrl = this.baseUrl.endsWith("/") ? this.baseUrl.slice(0, -1) : this.baseUrl;
  }
  static {
    __name(this, "Client");
  }
  objectUrl(key) {
    return `${this.baseUrl}/api/${this.workspace}/${encodeURIComponent(key)}`;
  }
  authHeaders(init) {
    const headers = new Headers(init);
    headers.set("Authorization", `Bearer ${this.token}`);
    return headers;
  }
  applyHeaders(h, headers) {
    if (headers != null) for (const [k, v] of Object.entries(headers)) h.set(`huly-header-${k}`, v);
  }
  applyMeta(h, meta) {
    if (meta != null) for (const [k, v] of Object.entries(meta)) h.set(`huly-meta-${k}`, v);
  }
  async status() {
    try {
      const res = await (0, import_utils.fetchSafe)(`${this.baseUrl}/status`);
      return res.ok;
    } catch {
      return false;
    }
  }
  async head(key, retryOptions) {
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(key),
      {
        method: "HEAD",
        headers: this.authHeaders()
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
      lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
      contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
      headers: res.headers
    };
  }
  async get(key, retryOptions) {
    try {
      const res = await (0, import_utils.fetchSafe)(
        this.objectUrl(key),
        {
          method: "GET",
          headers: this.authHeaders()
        },
        retryOptions
      );
      let body;
      if (res.ok) {
        body = res.body ?? void 0;
      }
      return {
        ok: res.ok,
        status: res.status,
        etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
        headers: res.headers,
        body
      };
    } catch (err) {
      if (err.name === "NotFoundError") {
        return {
          ok: false,
          status: 404,
          etag: void 0,
          headers: new Headers(),
          body: void 0
        };
      }
      throw err;
    }
  }
  async put(key, body, opts = {}, retryOptions) {
    const { mergeStrategy, headers, meta } = opts;
    const contentType = "contentType" in opts ? opts.contentType : void 0;
    const h = this.authHeaders();
    if (mergeStrategy != null) {
      h.set("Huly-Merge-Strategy", mergeStrategy);
    }
    if (contentType != null) {
      h.set("Content-Type", contentType);
    } else if (mergeStrategy === "jsonpatch") {
      h.set("Content-Type", "application/json");
    }
    this.applyHeaders(h, headers);
    this.applyMeta(h, meta);
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(key),
      {
        method: "PUT",
        headers: h,
        body
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
      lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
      contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
      headers: res.headers
    };
  }
  async patch(key, body, opts = {}, retryOptions) {
    const { contentType, headers, meta } = opts;
    const h = this.authHeaders();
    if (contentType != null) {
      h.set("Content-Type", contentType);
    }
    this.applyHeaders(h, headers);
    this.applyMeta(h, meta);
    const res = await (0, import_utils.fetchSafe)(
      this.objectUrl(key),
      {
        method: "PATCH",
        headers: h,
        body
      },
      retryOptions
    );
    return {
      ok: res.ok,
      status: res.status,
      etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
      lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
      contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
      headers: res.headers
    };
  }
  async getJson(key, retryOptions) {
    try {
      const res = await (0, import_utils.fetchSafe)(
        this.objectUrl(key),
        {
          method: "GET",
          headers: this.authHeaders()
        },
        retryOptions
      );
      let body;
      if (res.ok) {
        body = await res.json();
      }
      return {
        ok: res.ok,
        status: res.status,
        etag: (0, import_utils.unwrapEtag)(res.headers.get("ETag")),
        lastModified: (0, import_utils.unwrapLastModified)(res.headers.get("Last-Modified")),
        contentLength: (0, import_utils.unwrapContentLength)(res.headers.get("Content-Length")),
        headers: res.headers,
        body
      };
    } catch (err) {
      if (err.name === "NotFoundError") {
        return {
          ok: false,
          status: 404,
          etag: void 0,
          headers: new Headers(),
          body: void 0
        };
      }
      throw err;
    }
  }
  async putJson(key, json, options, retryOptions) {
    return await this.put(key, JSON.stringify(json), { ...options, mergeStrategy: "jsonpatch" }, retryOptions);
  }
  async patchJson(key, body, options, retryOptions) {
    return await this.patch(
      key,
      JSON.stringify(body),
      { ...options, contentType: "application/json-patch+json" },
      retryOptions
    );
  }
}
//# sourceMappingURL=client.js.map
